// src/SearchContext.js
import React, { createContext, useContext, useState } from 'react';

export const SearchContext = createContext();

export function SearchProvider({ children }) {
    const [searchKey, setSearchKey] = useState('');
    const [searchedData, setSearchedData] = useState([]);
    const [tabs, setTabs] = useState({});

    return (
        <SearchContext.Provider
            value={{
                searchKey,
                setSearchKey,
                searchedData,
                setSearchedData,
                tabs,
                setTabs,
            }}
        >
            {children}
        </SearchContext.Provider>
    );
}

export function useSearchContext() {
    return useContext(SearchContext);
}
